module.exports = __webpack_public_path__ + "static/media/edit.89db9e83.svg";